import React from 'react';
import './TransferSubmitted.scss';

import {imagePath} from '../index';
/*
import TransferSubmitted from './components/TransferSubmitted/TransferSubmitted';

function App() {
  return (
    <TransferSubmitted
      bank="MoniePoint"
      date="Mar 22, 2023"
      name="Cyber Coues"
      paymentMethod="Bank Transfer"
      amount="$ 160,905.00"
      onConfirm={() => console.log('Confirmed')}
    />
  );
}

export default App;
*/

const NumberFormat = ({number}) => {
  //const number = 1000000;
  const formattedNumber = new Intl.NumberFormat('en-US', {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(number||0));

  return <>{formattedNumber}</>;
};

const TransferSubmitted = ({
  bank,
  date,
  name,
  paymentMethod,
  amount,amount1,currency,
  onConfirm
}) => {


const NumberFormatfunc = (v) => {

  const num = Number(v);
  if (isNaN(num)) {
      //console.error("Invalid number:", number);
      return;  // or set default behavior here
  }
  const formattedNumber = new Intl.NumberFormat('en-US', {
      style: 'decimal', 
      minimumFractionDigits: 2, 
      maximumFractionDigits: 2,
  }).format(num); 

/*
  //const number = 1000000;
  const formattedNumber = new Intl.NumberFormat('en-US', {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(number||0));*/
  return formattedNumber;

  //return <>{formattedNumber}</>;
};

  return (
    <div className="ts0"> 
    <div className="transfer-submitted">
      {/*<header className="header">
        <div className="menu-icon">☰</div>
        <img src="/logo.png" alt="Capitals World" className="logo" />
        <div className="header-icons">
          <span className="notification">🔔</span>
          <span className="profile">👤</span>
        </div>
      </header>*/}

      <div className="confirmation-card">
        <div className="success-icon">
          {/*<svg viewBox="0 0 24 24" fill="none" className="check-icon">
            <path 
              d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" 
              fill="currentColor"
            />
          </svg>*/}
          <svg width="57" height="56" className="check-icon" viewBox="0 0 57 56" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="28.5" cy="28" r="28" fill="#23A26D" fill-opacity="0.12"/>
<path d="M28 14.6667C20.6533 14.6667 14.6666 20.6533 14.6666 28C14.6666 35.3467 20.6533 41.3333 28 41.3333C35.3466 41.3333 41.3333 35.3467 41.3333 28C41.3333 20.6533 35.3466 14.6667 28 14.6667ZM34.3733 24.9333L26.8133 32.4933C26.6266 32.68 26.3733 32.7867 26.1066 32.7867C25.84 32.7867 25.5866 32.68 25.4 32.4933L21.6266 28.72C21.24 28.3333 21.24 27.6933 21.6266 27.3067C22.0133 26.92 22.6533 26.92 23.04 27.3067L26.1066 30.3733L32.96 23.52C33.3466 23.1333 33.9866 23.1333 34.3733 23.52C34.76 23.9067 34.76 24.5333 34.3733 24.9333Z" fill="#23A26D"/>
</svg>

        </div>
        
        <h2>Transfer Submitted</h2>

        <div className="transfer-details">
          <DetailRow label="Bank" value={bank} />
          <DetailRow label="Date" value={date} />
          <DetailRow label="Name" value={name} />
          <DetailRow label="Payment Method" value={paymentMethod} />
          <DetailRow 
            label="Amount" 
            value={`${currency}${NumberFormatfunc(amount1)}`} 
            className="amount"
          />
        </div>

        <button 
          className="confirm-button"
          onClick={onConfirm}
        >
          Okay
        </button>
      </div>
    </div>
    </div>
  );
};

const DetailRow = ({ label, value, className = '' }) => (
  <div className={`detail-row ${className}`}>
    <span className="label">{label}</span>
    <span className="value">{value}</span>
  </div>
);

export default TransferSubmitted;